import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/profile/icon-setting.svg'
import _imports_1 from '@/assets/profile/icon-shield.svg'
import _imports_2 from '@/assets/profile/icon-group.svg'


const _hoisted_1 = { class: "utils__pageContainer userInfoView" }
const _hoisted_2 = { class: "userInfoView__info" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "userInfoView__links" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"#e9f5fc"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Setting"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#46c1fa"} }, "设置 / 修改密码", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"#e9f4f0"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Setting"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#11cd89"} }, "企业认证信息", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"#fef4e5"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Setting"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#fbb01b"} }, "关于我们", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { title: "个人信息" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.userName), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.roles, (item) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.roleName), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_app_icon, { type: "mobile" }),
            _createTextVNode(" " + _toDisplayString(_ctx.detail.phone), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'profile.set_or_modify_pwd' } }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'profile.confirm_credit', query: { goback: _ctx.$route.fullPath } }
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'other.about' } }, {
          default: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}